import React from "react";

const steps = [
  { order: "Phase 01", title: "Listen", text: "We start with your brand, the category, and what is actually understood about Türkiye internally. No template plans." },
  { order: "Phase 02", title: "Frame", text: "We write the Türkiye go-to-market — positioning, channel mix, budget and risks — at the level your global CFO can validate." },
  { order: "Phase 03", title: "Activate", text: "Digital, retail, PR and operations launch in parallel under one accountable producer at Vitalis. No agency relay race." },
  { order: "Phase 04", title: "Scale", text: "Year two is where launches either compound or fade. We stay involved long enough to make sure it compounds." }
];

const Approach = () => (
  <div className="approach">
    {steps.map((s) => (
      <div key={s.order} className="step">
        <span className="dot" />
        <div className="order">{s.order}</div>
        <h4>{s.title}</h4>
        <p>{s.text}</p>
      </div>
    ))}
  </div>
);

export default Approach;
